import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "请选择",
      multiple: _vm.multiple
    },
    on: {
      change: _vm.selectApp
    },
    model: {
      value: _vm.app_id,
      callback: function callback($$v) {
        _vm.app_id = $$v;
      },
      expression: "app_id"
    }
  }, _vm._l(_vm.appList, function (item) {
    return _c("el-option", {
      key: item.app_id,
      attrs: {
        label: item.name,
        value: item.app_id
      }
    });
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };